"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _md = require("react-icons/md");

var _Card = _interopRequireDefault(require("../../Card"));

var _Header = _interopRequireDefault(require("../../Card/Header"));

var _Image = _interopRequireDefault(require("../../Card/Image"));

var _Pill = _interopRequireDefault(require("../../Card/Pill"));

var _Section = _interopRequireDefault(require("../../Card/Section"));

var _SideBar = _interopRequireDefault(require("../SideBar"));

require("./style.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
* MerryGoRound Moment to interactively visualize works and publications.
*/
var MerryGoRoundMoment =
/*#__PURE__*/
function (_Component) {
  _inherits(MerryGoRoundMoment, _Component);

  function MerryGoRoundMoment(props) {
    var _this;

    _classCallCheck(this, MerryGoRoundMoment);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MerryGoRoundMoment).call(this, props));
    var horseCount = props.children.length;
    _this.state = {
      currentHorse: null,
      sidebar: false,
      horseCount: horseCount,
      withNav: horseCount > 2
    };
    _this.handleCloseSidebar = _this.handleCloseSidebar.bind(_assertThisInitialized(_this));
    _this.handleSelectHorse = _this.handleSelectHorse.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MerryGoRoundMoment, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.withNav) {
        var node = _reactDom.default.findDOMNode(this);

        this.loadMerryGoRound(node);
      }

      ;
    }
  }, {
    key: "loadMerryGoRound",
    value: function loadMerryGoRound(node) {
      // TODO: Integrate this better with react.
      // Kinda ugly mixing vanillar js here
      var root = node.querySelector('.merry_go_round-wrapper');
      var figure = root.querySelector('.merry-go-round_figure'),
          nextNavigator = root.querySelector('.merry-go-round-navigate-next'),
          prevNavigator = root.querySelector('.merry-go-round-navigate-prev'),
          images = figure.children,
          n = images.length,
          gap = 80,
          bfc = 'bfc' in root.dataset,
          theta = 2 * Math.PI / n,
          currImage = 0;
      setupCarousel(currImage, n, parseFloat(getComputedStyle(images[0]).width));
      window.addEventListener('resize', function () {
        var s = parseFloat(getComputedStyle(images[0]).width);
        setupCarousel(currImage, n, s);
      });
      setupNavigation();

      function setupCarousel(horseIndex, n, s) {
        var apothem = s / (2 * Math.tan(Math.PI / n));
        var transformOrigin = "50% 50% ".concat(-apothem, "px");
        figure.style.transformOrigin = transformOrigin;

        for (var i = 0; i < n; i++) {
          images[i].style.padding = gap + 'px';
        }

        for (i = 1; i < n; i++) {
          images[i].style.transformOrigin = transformOrigin;
          images[i].style.transform = "rotateY(".concat(i * theta, "rad)");
        }

        if (bfc) {
          for (i = 0; i < n; i++) {
            images[i].style.backfaceVisibility = 'hidden';
          }
        }

        rotateCarousel(horseIndex);
      }

      function setupNavigation() {
        nextNavigator.addEventListener('click', function (e) {
          e.stopPropagation();
          currImage++;
          rotateCarousel(currImage);
        }, true);
        prevNavigator.addEventListener('click', function (e) {
          e.stopPropagation();
          currImage--;
          rotateCarousel(currImage);
        }, true);
      }

      function rotateCarousel(imageIndex) {
        figure.style.transform = "rotateY(".concat(imageIndex * -theta, "rad)");
      }
    }
  }, {
    key: "handleCloseSidebar",
    value: function handleCloseSidebar() {
      this.setState({
        sidebar: false
      });
    }
  }, {
    key: "handleSelectHorse",
    value: function handleSelectHorse(horse) {
      this.setState({
        currentHorse: horse,
        sidebar: true
      });
    }
  }, {
    key: "renderHorses",
    value: function renderHorses() {
      var _this2 = this;

      if (!this.state.withNav) {
        return _react.default.createElement(_core.Grid, {
          container: true,
          justify: "center",
          spacing: 5
        }, _react.default.Children.map(this.props.children, function (child, index) {
          return _react.default.createElement(_core.Grid, {
            item: true,
            xs: 5,
            index: index,
            onClick: function onClick() {
              return _this2.handleSelectHorse(child);
            }
          }, child);
        }));
      }

      return _react.default.Children.map(this.props.children, function (child, index) {
        return _react.default.createElement("div", {
          className: "merry-go-round__horse",
          index: index,
          onClick: function onClick() {
            return _this2.handleSelectHorse(child);
          }
        }, child);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var handleSelectHorse = this.handleSelectHorse;
      var _this$props = this.props,
          children = _this$props.children,
          sideBarContent = _this$props.sideBarContent,
          style = _this$props.style;
      var _this$state = this.state,
          currentHorse = _this$state.currentHorse,
          sidebar = _this$state.sidebar,
          withNav = _this$state.withNav;
      var layout = "merry_go_round";
      return _react.default.createElement(_SideBar.default, _extends({}, this.props, {
        layout: layout,
        onClose: this.handleCloseSidebar,
        sidebar: sidebar,
        sideBarContent: sideBarContent(currentHorse)
      }), _react.default.createElement("div", {
        className: "merry_go_round-wrapper",
        style: style
      }, _react.default.createElement("div", {
        className: this.state.withNav ? "merry-go-round_figure" : "merry-go-round_figure-no-nav"
      }, this.renderHorses()), withNav && _react.default.createElement("div", {
        className: "merry-go-round-navigation"
      }, _react.default.createElement(_core.Button, {
        className: "merry-go-round-navigate merry-go-round-navigate-prev",
        variant: "contained"
      }, _react.default.createElement(_md.MdArrowBack, null)), _react.default.createElement(_core.Button, {
        className: "merry-go-round-navigate merry-go-round-navigate-next",
        variant: "contained"
      }, _react.default.createElement(_md.MdArrowForward, null)))));
    }
  }]);

  return MerryGoRoundMoment;
}(_react.Component);

exports.default = MerryGoRoundMoment;

_defineProperty(MerryGoRoundMoment, "propTypes", {
  /** Determines the background and text color of the `Moment` header. */
  color: _propTypes.default.shape({
    background: _propTypes.default.string,
    text: _propTypes.default.string
  }),

  /** Determines the `SideBarSection` `Icon` of the `Moment`. */
  icon: _propTypes.default.element,

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: _propTypes.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: _propTypes.default.string,

  /** Render function to fill the `SideBar` `Drawer`. */
  sideBarContent: _propTypes.default.func.isRequired,

  /** Class name for the `SideBar` `Drawer` root. */
  sideBarClassName: _propTypes.default.string,

  /** Styling object of the moment body container */
  style: _propTypes.default.object,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: _propTypes.default.string,

  /** Main heading element of the `Moment` */
  title: _propTypes.default.node,

  /** The type of `Moment` */
  type: _propTypes.default.string
});

_defineProperty(MerryGoRoundMoment, "defaultProps", {
  type: "merry_go_round",
  data: {},
  sideBarContent: function sideBarContent(currentHorse) {
    return currentHorse;
  },
  style: {}
});